/*
export interface IJoinUs {
    id: any;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    businessName: string;
    categoryId: number;
    educationId: number;
    sportsId: number;
    otherCat: string;
    otherEdu: string;
    otherSpo: string;
    category: string;
    education: string;
    sports: string;
}*/
export interface IDefaultResult {
    errorOccured: boolean;
    errorMessage: string;
    result: any;
}

export interface Islider{    
    id: number;
    companyID: any;
    sortNumber: number;
    title: string;
    titleAr: string;
    description: string;
    descriptionAr: string;
    redirectionURL: string;
    imageURL:string;
    expDate: Date;
    notes: string;
    status: boolean;
}

// NEW ONE
export interface IJoinUs {
    id: any;
    firstName: string; // s
    lastName: string;
    email: string;
    phone: string;
    businessName: string;
    categoryId: number;
    categoryName: string;
    subCategoryName: string;
    notes: string;
    creationDate: Date;
    assignedBy: any;
    assignedDate: Date;
    assignTo: any;
    seenDate: Date;
    replyDate: Date;
    replyResult: string;
    key: string;
    replyNotes: string; // end
    educationId: number;
    sportsId: number;
    otherCat: string;
    otherEdu: string;
    otherSpo: string;
    category: string;
    education: string;
    sports: string;


    merchantId:string;
    merchantName:string;
    branchId:string;
    branchName:string;
}


// NEW ONE
export interface IContactUs {
    id: any;
    fullName: string; // s
    email: string;
    mobileNumber: string;
    subject: string;
    question: string;
    lang: string;
    submissionDate: Date;
    answerDate: Date;
    sendTo: string;
    isAnswered: boolean;




}

export interface Icommon {
    id: any;
    name: string;
    imageURL: string;
    coverURL: string;
    notes: string;
    value: boolean;
}